import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

//antd components
import { Modal, Button } from 'antd';

//styles
import './style.scss';

function ModalChangePresence({
  okHandle,
  cancelHandle,
  content,
  isOpen,
  // actions
  setOpen,
  // default props
  className,
  children,
}) {
  const mainClassName = classNames('modal-modifier', className);

  const handleOk = useCallback(() => {
    okHandle !== undefined && okHandle();
    setOpen(!isOpen);
  }, [okHandle, isOpen]);

  const handleCancel = useCallback(() => {
    cancelHandle !== undefined && cancelHandle();
    setOpen(!isOpen);
  }, [cancelHandle, isOpen]);

  const renderModal = useMemo(() => (
    <Modal
      open={isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      className="modal-modifier-wrapper"
    >
      <div className="wrapper-content">
        <h3 className="content-title">Modifier les présences</h3>

        {(content || children) && (
          <div
            className="content-text"
            dangerouslySetInnerHTML={{ __html: content || children }}
          />
        )}

      </div>
      <div className="wrapper-btn">
        <Button onClick={handleOk} className="btn-change">
          Modifier les présences
        </Button>
        <Button onClick={handleCancel} className="btn-return">
          Retour
        </Button>
      </div>
    </Modal>
  ), [isOpen, content, children]);

  return (
    <div className={mainClassName}>
      {renderModal}
    </div>
  );
}

ModalChangePresence.defaultProps = {
  isOpen: false,
  content: `<p>Vous avez déjà effectué le contrôle des présences pour ce cours.</p><p>Voulez-vous modifier les présences de ce cours?</p>`,
};
ModalChangePresence.propTypes = {
  content: PropTypes.string,
  okHandle: PropTypes.func,
  cancelHandle: PropTypes.func,
};

export default ModalChangePresence;
